const base = '/api/public'

async function req(path, options = {}) {
  const res = await fetch(base + path, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}))
    throw new Error(detail.detail?.message || detail.detail || "Le service ne répond pas")
  }
  return res.json()
}

export const api = {
  site: () => req('/site'),
  form: (slug) => req(`/forms/${slug}`),
  submit: (slug, payload) => req(`/forms/${slug}/submit`, { method: 'POST', body: JSON.stringify(payload) }),
  slots: (key) => req(`/agenda/${key}/slots`),
  follow: (number, code) => req(`/requests/${number}?code=${encodeURIComponent(code)}`),
  answer: (number, code, payload) =>
    req(`/requests/${number}/answer?code=${encodeURIComponent(code)}`, {
      method: 'POST', body: JSON.stringify(payload),
    }),
}
